(function (global) {
  'use strict';

  var scheduledRoots = new WeakSet();
  var priceTimer;

  function getState(now, dates) {
    if (now < dates.start) return 'upcoming';
    if (now < dates.urgency) return 'active';
    if (now < dates.end) return 'countdown';
    return 'ended';
  }

  function unit(value, singular, plural) {
    return value + ' ' + (value === 1 ? singular : plural);
  }

  function formatRemaining(milliseconds) {
    var totalSeconds = Math.max(0, Math.ceil(milliseconds / 1000));
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;
    var parts = [];

    if (days > 0) parts.push(unit(days, 'giorno', 'giorni'));
    if (hours > 0 || days > 0) parts.push(unit(hours, 'ora', 'ore'));
    if (minutes > 0 || hours > 0 || days > 0) parts.push(unit(minutes, 'minuto', 'minuti'));
    parts.push(unit(seconds, 'secondo', 'secondi'));

    if (parts.length === 1) return parts[0];
    return parts.slice(0, -1).join(', ') + ' e ' + parts[parts.length - 1];
  }

  function readDates(root) {
    return {
      start: Date.parse(root.dataset.start),
      urgency: Date.parse(root.dataset.urgency),
      end: Date.parse(root.dataset.end),
    };
  }

  function render(root, now) {
    var copy = root.querySelector('[data-cio-promo-copy]');
    var time = root.querySelector('[data-cio-promo-time]');
    var dates = readDates(root);
    var state = getState(now, dates);

    if (state === 'ended') {
      root.hidden = true;
      return false;
    }

    root.hidden = false;

    time.hidden = state !== 'countdown';
    if (state === 'upcoming') {
      copy.textContent = root.dataset.copyUpcoming;
    } else if (state === 'active') {
      copy.textContent = root.dataset.copyActive;
    } else {
      copy.textContent = root.dataset.copyCountdown;
      time.textContent = 'Meno di una settimana: ' + formatRemaining(dates.end - now);
    }

    return true;
  }

  function schedule(root) {
    if (scheduledRoots.has(root)) return;
    scheduledRoots.add(root);
    function update() {
      if (!root.isConnected) return;
      var now = Date.now();
      if (!render(root, now)) return;
      var wait = 1000 - (now % 1000) + 50;
      global.setTimeout(update, wait);
    }

    update();
  }

  function updatePrices() {
    var now = Date.now();
    var nextEnd;
    document.querySelectorAll('[data-cio-offer-price]').forEach(function (price) {
      var end = Date.parse(price.dataset.cioOfferEnd);
      if (!Number.isFinite(end)) return;
      if (now < end) {
        nextEnd = nextEnd === undefined ? end : Math.min(nextEnd, end);
        return;
      }
      price.querySelector('[data-cio-offer-current]').textContent = price.dataset.originalMoney;
      price.querySelector('[data-cio-offer-original]').hidden = true;
      price.querySelector('[data-cio-offer-note]').hidden = true;
    });
    if (nextEnd !== undefined && priceTimer === undefined) {
      priceTimer = global.setTimeout(function () {
        priceTimer = undefined;
        updatePrices();
      }, Math.min(nextEnd - now + 50, 2147483647));
    }
  }

  function init() {
    document.querySelectorAll('[data-cio-promo]').forEach(schedule);
    updatePrices();
  }

  global.CioPromoCountdown = {
    formatRemaining: formatRemaining,
    getState: getState,
    render: render,
  };

  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(window);
